module.exports = __webpack_public_path__ + "static/media/insuranceLogo.b4080d50.svg";